import {repeat} from 'lit-html/directives/repeat';
import {until} from 'lit-html/directives/until';

const standardsColors = [
  '#e2f2ff',
  '#ffdec2',
  '#d2ffd3',
  '#eaddff',
  '#fff0a0'
];

export default (ctx, html) => {
  if (!ctx['external-standards']) {
    return ``;
  }

  return html`
  ${repeat(ctx['external-standards'], (externalStandard) => externalStandard, (externalStandard, index) => html`
    <div class="${ctx['row-classname']} py-3 border-bottom">
      <div>
        <span class="mr-3">${until(
          ctx._r(
            ctx.__('<tt-+lelV/89>', '%r1% %r2%:'),
            externalStandard.standard_set_label,
            externalStandard.parent_taxonomy?.type,
          ),
        )}</span>
        ${externalStandard.parent_taxonomy?.names?.join(', ')}
      </div>
      <div>
        ${repeat(
          [...externalStandard.standard_codes].sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {numeric: true})
          ),
          (standardCode) => standardCode,
          (standardCode) => html`
            <div
              class="d-inline-block px-3 py-1 rounded mr-3 mb-1 text-center standard-code"
              style="background-color:${standardsColors[index]}"
            >${standardCode?.name}</div>
          `
        )}
      </div>
    </div>
  `)}
`;
};
